
<div>
  <div v-if="displayAcceptReject">
    <div v-if="view === acceptReject.Horizontal">
      <div class="btn-group d-flex align-items-center" role="group">
        <button
          type="button"
          class="btn btn-xs btn-success"
          v-on:click="processDelegatedItem(true, $event)"
        >
          Accept
        </button>
        <button
          type="button"
          class="btn btn-xs btn-danger"
          v-on:click="processDelegatedItem(false, $event)"
        >
          Reject
        </button>
      </div>
    </div>

    <div v-if="view === acceptReject.Vertical">
      <div class="mt-2">
        <button class="btn btn-block btn-success" @click="processDelegatedItem(true)">
          <i class="fas fa-check icon-left"></i>
          Accept
        </button>
      </div>

      <div class="mt-2">
        <button class="btn btn-block btn-danger" @click="processDelegatedItem(false)">
          <i class="fas fa-share icon-left"></i>
          Reject
        </button>
      </div>
    </div>
  </div>
</div>
